
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeAuthenticatedRequest } from "../utils/apiRequest";
import { useAuth } from "../contexts/authContext";
const MealPopup = ({ city, cities, onClose, onAdd, editData, restaurantName }) => {
  const location = useLocation();
  const { token, currentUser } = useAuth();

  const [selectedCity, setSelectedCity] = useState(
    city || editData?.city || ""
  );
  const [hotels, setHotels] = useState([]);
  const [meals, setMeals] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(editData?.hotel || "");
  const [selectedMeal, setSelectedMeal] = useState(editData?.meal || "");
  const [arrangement, setArrangement] = useState(
    editData?.arrangement || "Own Arrangement"
  );
  const [inclusion, setInclusion] = useState(
    editData?.inclusion === false || editData?.inclusion === "False" ? false : true
  );
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formError, setFormError] = useState("");

  const [restaurants, setRestaurants] = useState([]);

  const [selectedRestaurant, setSelectedRestaurant] = useState(restaurantName || '');
  
  
  // Fetch meal data using the provided endpoint
  const fetchMealData = async (city) => {
    if (!token) {
      console.error("Token not available");
      return;
    }
    setIsLoading(true);
    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_meal_data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ city_name: [city] }),
        }
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching meal data: ${response.statusText}`);
      }
  
      const result = await response.json();
      console.log("Fetched Meal Data:", result);
  
      if (result.data && Array.isArray(result.data)) {
        // Extract restaurants
        setRestaurants(
          result.data.map((restaurant) => ({
            meal_id: restaurant.meal_id,
            resturant_name: restaurant.resturant_name,
          }))
        );
  
        // Extract meal plan types (breakfast, lunch, dinner)
        const mealPlanTypes = result.data.flatMap((restaurant) =>
          restaurant.meals.flatMap((meal) => Object.keys(meal))
        );
  
        setMeals([...new Set(mealPlanTypes)]); // Ensure unique meal types
      } else {
        console.warn("Unexpected data format:", result);
      }
    } catch (error) {
      console.error("Error fetching meal data:", error.message);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  
  useEffect(() => {
    if (selectedCity) {
      fetchMealData(selectedCity);
    }
  }, [selectedCity]);

  const handleAdd = () => {
    if (!selectedRestaurant || !selectedMeal) {
      alert("Please select restaurant name and meal plan.");
      return;
    }
  
    const mealData = {
      activity_type: "meal",
      restaurant_name: selectedRestaurant,
      meal: selectedMeal,
      arrangement,
      inclusion,
    };
    onAdd(mealData);
    onClose();
  };
  
  
  

  const handleSave = () => {
    onAdd({ restaurant_name: selectedRestaurant });
    onClose();
  };

  useEffect(() => {
    if (editData) {
      setSelectedRestaurant(editData.restaurant_name); // Set the default if editing
      setInclusion(editData?.inclusion === false || editData?.inclusion === "False" ? false : true); // Ensure the inclusion value persists
    }
  }, [editData]);
  
  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 shadow-lg w-1/2">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{editData ? "Edit Meal" : "Add Meal"}</h2>
          
          <button onClick={onClose} className="text-gray-600 hover:text-black">
            ✖
          </button>
        </div>

        {isLoading ? (
          <p>Loading meal data...</p>
        ) : (
          <>
            {/* City Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Select City:
              </label>
              <select
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded mt-1"
              >
                <option value="">-- Select City --</option>
                {cities.map((city) => (
                  <option key={city.city_id} value={city.city_name}>
                    {city.city_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Restaurant Dropdown */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700">
    Select Restaurant:
  </label>
  <select
    value={selectedRestaurant}
    onChange={(e) => setSelectedRestaurant(e.target.value)}
    className="w-full p-2 border border-gray-300 rounded mt-1"
  >
    <option value="">-- Select Restaurant --</option>
    {restaurants.map((restaurant) => (
      <option key={restaurant.meal_id} value={restaurant.resturant_name}>
        {restaurant.resturant_name}
      </option>
    ))}
  </select>
</div>



           {/* Meal Plan Dropdown */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700">
    Select Meal Plan:
  </label>
  <select
    value={selectedMeal}
    onChange={(e) => setSelectedMeal(e.target.value)}
    className="w-full p-2 border border-gray-300 rounded mt-1"
  >
    <option value="">-- Select Meal Plan --</option>
    {meals.map((mealType, index) => (
      <option key={index} value={mealType}>
        {mealType.charAt(0).toUpperCase() + mealType.slice(1)} {/* Capitalize meal type */}
      </option>
    ))}
  </select>
</div>


            {/* Arrangement Buttons */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Arrangement:
              </label>
              <div className="flex space-x-2">
                <button
                  className={`flex-1 p-2 rounded border text-sm font-medium ${
                    arrangement === "Own Arrangement"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300"
                  }`}
                  onClick={() => setArrangement("Own Arrangement")}
                >
                  Own Arrangement
                </button>
                <button
                  className={`flex-1 p-2 rounded border text-sm font-medium ${
                    arrangement === "Company Arrangement"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300"
                  }`}
                  onClick={() => setArrangement("Company Arrangement")}
                >
                  Company Arrangement
                </button>
              </div>
            </div>

            {/* Inclusion Buttons */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Inclusion:
              </label>
              <div className="flex space-x-2">
                <button
                  className={`flex-1 p-2 rounded border text-sm font-medium ${
                    inclusion
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300"
                  }`}
                  onClick={() => setInclusion(true)}
                >
                  Included
                </button>
                <button
                  className={`flex-1 p-2 rounded border text-sm font-medium ${
                    !inclusion
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300"
                  }`}
                  onClick={() => setInclusion(false)}
                >
                  Excluded
                </button>
              </div>
            </div>
          </>
        )}

<button
  onClick={handleAdd}
  className="bg-blue-600 text-white px-4 py-2 rounded w-full mt-8"
>
  {editData ? "Save Changes" : "Add Meal"}
</button>

       

      </div>
    </div>
  );
};

export default MealPopup;